import axios from "axios";

export const BRANCH_URL = "/Branch";
export const TEACHER_URL = "/Teacher";
export const PERSONNEL_URL = "/Personnel";

/** Belli Bir Öğretmen Listesini Elde Eder */
export function getTeachers(queryParams) {
  return axios.post(`${TEACHER_URL}/GetTeachers`, queryParams);
}

/** Belli Bir Öğretmen Listesini Sayfalama Olmadan Elde Eder */
export function getAllTeachers(queryParams) {
  return axios.post(`${TEACHER_URL}/GetAllTeachers`, queryParams);
}

/** Mevcut Okulun Aktif Branş Listesini Elde Eder */
export function getBranches() {
  return axios.get(`${BRANCH_URL}/GetBranches`);
}

/** Yeni Bir Öğretmen Elde Eder */
export function getNewTeacher() {
  return axios.get(TEACHER_URL);
}

/** Belli Bir Öğretmeni Elde Eder */
export function getTeacher(id) {
  return axios.get(`${TEACHER_URL}/${id}`);
}

/** Belli Bir Öğretmeni Kaydeder */
export function saveTeacher(teacher) {
  return axios.post(TEACHER_URL, teacher);
}

/** Belli Bir Öğretmen Listesinin Sözleşmelerini Mevcut Dönem İçin Yeniler */
export function renewContracts(ids) {
  return axios.post(`${PERSONNEL_URL}/RenewContracts`, { ids });
}

/** Belli Bir Öğretmen Listesini Siler */
export function deleteTeachers(ids) {
  return axios.post(`${PERSONNEL_URL}/Delete`, { ids });
}

/** Belli Bir Öğretmen Listesinin Belli Bir Dönemdeki Sözleşmelerini Siler */
export function deleteContracts(term, ids) {
  return axios.post(`${PERSONNEL_URL}/DeleteContracts`, { term, ids });
}